import React from 'react';
import styles from './styles.module.scss';
import Image from 'react-bootstrap/Image';
import money from '../../../../icons/save-money.png';
import happy from '../../../../icons/costumer.png';
import service from '../../../../icons/service.png';

export function HappyCustomers() {

    return(
        <div className={`rounded-card ${styles.cardContainer}`}>
            <div className={`rounded-card ${styles.childCard}`}>
                <div className={styles.iconContainer}>
                    <div className={styles.iconChild}>
                        <Image src={service} fluid alt="lightning-icon" />
                    </div>
                    <div className={styles.iconChild}>
                        <Image src={happy} fluid alt="lightning-icon" />
                    </div>
                    <div className={styles.iconChild}>
                        <Image src={money} fluid alt="lightning-icon" />
                    </div>
                </div>
            </div>
            <h3>Fornøydhetsgaranti</h3>
            <p>
                100% fornøyd eller pengene tilbake!
            </p>
        </div>
    )
}